import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BlackjackSettings = () => {
  const [settings, setSettings] = useState({
    minBet: 10,
    maxBet: 500,
    rtp: 0.97,
    isActive: true,
    logoUrl: null,
    cardBackUrl: null
  });
  const [logoFile, setLogoFile] = useState(null);
  const [cardBackFile, setCardBackFile] = useState(null);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [selectedCardBackUrl, setSelectedCardBackUrl] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [showImageGallery, setShowImageGallery] = useState(false);
  const [showCardBackGallery, setShowCardBackGallery] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loadingImages, setLoadingImages] = useState(false);

  useEffect(() => {
    fetchSettings();
    fetchUploadedImages();
  }, []);

  const fetchSettings = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/games/settings/blackjack', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const logoUrl = response.data.logoUrl || response.data.logo_url || null;
      const cardBackUrl = response.data.cardBackUrl || response.data.card_back_url || null;
      setSettings({
        minBet: response.data.minBet || response.data.min_bet || 10,
        maxBet: response.data.maxBet || response.data.max_bet || 500,
        rtp: response.data.rtp || 0.97,
        isActive: response.data.isActive !== undefined ? response.data.isActive : (response.data.is_active === 1 || response.data.is_active === true),
        logoUrl: logoUrl,
        cardBackUrl: cardBackUrl
      });
      setSelectedImageUrl(logoUrl);
      setSelectedCardBackUrl(cardBackUrl);
    } catch (error) {
      console.error('Error fetching settings:', error);
      // Settings might not exist yet, that's okay
    }
  };

  const fetchUploadedImages = async () => {
    try {
      setLoadingImages(true);
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/games/images', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUploadedImages(response.data || []);
    } catch (error) {
      console.error('Error fetching images:', error);
    } finally {
      setLoadingImages(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      
      formData.append('minBet', settings.minBet);
      formData.append('maxBet', settings.maxBet);
      formData.append('rtp', settings.rtp);
      formData.append('isActive', settings.isActive);
      
      if (logoFile) {
        formData.append('logo', logoFile);
      } else if (selectedImageUrl) {
        formData.append('logoUrl', selectedImageUrl);
      }
      
      if (cardBackFile) {
        formData.append('cardBack', cardBackFile);
      } else if (selectedCardBackUrl) {
        formData.append('cardBackUrl', selectedCardBackUrl);
      }

      await axios.put('/api/games/settings/blackjack', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      alert('Blackjack ayarları güncellendi');
      setLogoFile(null);
      setCardBackFile(null);
      setShowImageGallery(false);
      setShowCardBackGallery(false);
      fetchSettings();
      fetchUploadedImages();
    } catch (error) {
      console.error('Error saving settings:', error);
      alert(error.response?.data?.error || 'Ayarlar kaydedilirken bir hata oluştu');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <h2 className="text-2xl font-bold text-gold mb-6">Blackjack Ayarları</h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-white mb-2 font-medium">
              Minimum Bahis (Sagu Coin) *
            </label>
            <input
              type="number"
              value={settings.minBet}
              onChange={(e) => setSettings({ ...settings, minBet: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              required
              min="1"
            />
            <p className="text-white/60 text-sm mt-1">Kullanıcıların yapabileceği minimum bahis miktarı</p>
          </div>

          <div>
            <label className="block text-white mb-2 font-medium">
              Maksimum Bahis (Sagu Coin) *
            </label>
            <input
              type="number"
              value={settings.maxBet}
              onChange={(e) => setSettings({ ...settings, maxBet: parseInt(e.target.value) || 0 })}
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              required
              min="1"
            />
            <p className="text-white/60 text-sm mt-1">Kullanıcıların yapabileceği maksimum bahis miktarı</p>
          </div>
        </div>

        <div>
          <label className="block text-white mb-2 font-medium">
            RTP (Return to Player) - Kazanç Oranı *
          </label>
          <div className="flex items-center gap-4">
            <input
              type="number"
              step="0.01"
              min="0"
              max="1"
              value={settings.rtp}
              onChange={(e) => setSettings({ ...settings, rtp: parseFloat(e.target.value) || 0 })}
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              required
            />
            <div className="min-w-[200px]">
              <div className="bg-navy-800 p-3 rounded-lg border border-gold/20">
                <div className="text-gold font-bold text-lg">
                  {(settings.rtp * 100).toFixed(2)}%
                </div>
                <div className="text-white/60 text-sm">
                  {settings.rtp >= 0.95 ? 'Yüksek' : settings.rtp >= 0.90 ? 'Orta' : 'Düşük'} Kazanç
                </div>
              </div>
            </div>
          </div>
          <p className="text-white/60 text-sm mt-1">
            0.78–0.999 arası önerilir (ör. 0.97 = %97). Sunucu bu değeri kullanır: kazanç ödemeleri referans RTP’ye göre çarpılır; düşük RTP’de krupiye/oyuncu kartları istatistiksel olarak eve yönlendirilir. %100’e yakın = neredeyse adil oyun.
          </p>
        </div>

        <div>
          <label className="block text-white mb-2 font-medium">
            Oyun Logosu
          </label>
          
          {/* Dosya Seçme */}
          <div className="mb-4">
            <label className="block text-white/80 text-sm mb-2">Yeni Dosya Yükle:</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files[0]) {
                  setLogoFile(e.target.files[0]);
                  setSelectedImageUrl(null);
                }
              }}
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            />
          </div>

          {/* Mevcut Resimlerden Seç */}
          <div className="mb-4">
            <div className="flex items-center justify-between mb-2">
              <label className="block text-white/80 text-sm">Mevcut Resimlerden Seç:</label>
              <button
                type="button"
                onClick={() => {
                  setShowImageGallery(!showImageGallery);
                  if (!showImageGallery) {
                    fetchUploadedImages();
                  }
                }}
                className="text-gold hover:text-yellow-400 text-sm font-medium"
              >
                {showImageGallery ? 'Gizle' : 'Göster'}
              </button>
            </div>
            
            {showImageGallery && (
              <div className="bg-navy-800 rounded-lg p-4 border border-gold/20 max-h-96 overflow-y-auto">
                {loadingImages ? (
                  <div className="text-center text-white/60 py-8">Yükleniyor...</div>
                ) : uploadedImages.length === 0 ? (
                  <div className="text-center text-white/60 py-8">Henüz yüklenmiş resim yok</div>
                ) : (
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {uploadedImages.map((image, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setSelectedImageUrl(image.url);
                          setLogoFile(null);
                        }}
                        className={`relative cursor-pointer rounded-lg overflow-hidden border-2 transition-all ${
                          selectedImageUrl === image.url
                            ? 'border-gold ring-2 ring-gold'
                            : 'border-transparent hover:border-gold/50'
                        }`}
                      >
                        <img
                          src={image.url}
                          alt={image.filename}
                          className="w-full h-24 object-cover"
                        />
                        {selectedImageUrl === image.url && (
                          <div className="absolute inset-0 bg-gold/20 flex items-center justify-center">
                            <div className="bg-gold text-navy-900 rounded-full p-1">
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Önizleme */}
          {(logoFile || selectedImageUrl) && (
            <div className="mt-4">
              <p className="text-white/60 text-sm mb-2">
                {logoFile ? 'Yeni Logo Önizleme:' : 'Seçilen Logo:'}
              </p>
              <div className="bg-navy-900 rounded-lg p-4 border border-gold/20">
                <img
                  src={logoFile ? URL.createObjectURL(logoFile) : selectedImageUrl}
                  alt="Preview"
                  className="h-32 w-auto mx-auto object-contain"
                />
              </div>
            </div>
          )}

          {settings.logoUrl && !logoFile && !selectedImageUrl && (
            <div className="mt-4">
              <p className="text-white/60 text-sm mb-2">Mevcut Logo:</p>
              <div className="bg-navy-900 rounded-lg p-4 border border-gold/20">
                <img
                  src={settings.logoUrl}
                  alt="Blackjack Logo"
                  className="h-32 w-auto mx-auto object-contain"
                />
              </div>
            </div>
          )}

          <p className="text-white/60 text-sm mt-2">Oyunlar sayfasında gösterilecek logo</p>
        </div>

        <div>
          <label className="block text-white mb-2 font-medium">
            Kart Arkası Resmi (Krupiyer Kapalı Kart)
          </label>
          
          {/* Dosya Seçme */}
          <div className="mb-4">
            <label className="block text-white/80 text-sm mb-2">Yeni Dosya Yükle:</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files[0]) {
                  setCardBackFile(e.target.files[0]);
                  setSelectedCardBackUrl(null);
                }
              }}
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            />
          </div>

          {/* Mevcut Resimlerden Seç */}
          <div className="mb-4">
            <div className="flex items-center justify-between mb-2">
              <label className="block text-white/80 text-sm">Mevcut Resimlerden Seç:</label>
              <button
                type="button"
                onClick={() => {
                  setShowCardBackGallery(!showCardBackGallery);
                  if (!showCardBackGallery) {
                    fetchUploadedImages();
                  }
                }}
                className="text-gold hover:text-yellow-400 text-sm font-medium"
              >
                {showCardBackGallery ? 'Gizle' : 'Göster'}
              </button>
            </div>
            
            {showCardBackGallery && (
              <div className="bg-navy-800 rounded-lg p-4 border border-gold/20 max-h-96 overflow-y-auto">
                {loadingImages ? (
                  <div className="text-center text-white/60 py-8">Yükleniyor...</div>
                ) : uploadedImages.length === 0 ? (
                  <div className="text-center text-white/60 py-8">Henüz yüklenmiş resim yok</div>
                ) : (
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {uploadedImages.map((image, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setSelectedCardBackUrl(image.url);
                          setCardBackFile(null);
                        }}
                        className={`relative cursor-pointer rounded-lg overflow-hidden border-2 transition-all ${
                          selectedCardBackUrl === image.url
                            ? 'border-gold ring-2 ring-gold'
                            : 'border-transparent hover:border-gold/50'
                        }`}
                      >
                        <img
                          src={image.url}
                          alt={image.filename}
                          className="w-full h-24 object-cover"
                        />
                        {selectedCardBackUrl === image.url && (
                          <div className="absolute inset-0 bg-gold/20 flex items-center justify-center">
                            <div className="bg-gold text-navy-900 rounded-full p-1">
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Önizleme */}
          {(cardBackFile || selectedCardBackUrl) && (
            <div className="mt-4">
              <p className="text-white/60 text-sm mb-2">
                {cardBackFile ? 'Yeni Kart Arkası Önizleme:' : 'Seçilen Kart Arkası:'}
              </p>
              <div className="bg-navy-900 rounded-lg p-4 border border-gold/20">
                <img
                  src={cardBackFile ? URL.createObjectURL(cardBackFile) : selectedCardBackUrl}
                  alt="Preview"
                  className="h-32 w-auto mx-auto object-contain"
                />
              </div>
            </div>
          )}

          {settings.cardBackUrl && !cardBackFile && !selectedCardBackUrl && (
            <div className="mt-4">
              <p className="text-white/60 text-sm mb-2">Mevcut Kart Arkası:</p>
              <div className="bg-navy-900 rounded-lg p-4 border border-gold/20">
                <img
                  src={settings.cardBackUrl}
                  alt="Card Back"
                  className="h-32 w-auto mx-auto object-contain"
                />
              </div>
            </div>
          )}

          <p className="text-white/60 text-sm mt-2">Krupiyerin kapalı kartı için kullanılacak resim</p>
        </div>

        <div className="flex items-center gap-4">
          <label className="flex items-center gap-2 text-white">
            <input
              type="checkbox"
              checked={settings.isActive}
              onChange={(e) => setSettings({ ...settings, isActive: e.target.checked })}
              className="w-5 h-5"
            />
            <span className="font-medium">Oyunu Aktif Et</span>
          </label>
        </div>

        <div className="bg-navy-800/50 p-4 rounded-lg border border-gold/20">
          <h3 className="text-gold font-semibold mb-2">Bilgilendirme</h3>
          <ul className="text-white/80 text-sm space-y-1">
            <li>• Minimum bahis: {settings.minBet} Sagu Coin</li>
            <li>• Maksimum bahis: {settings.maxBet} Sagu Coin</li>
            <li>• RTP: %{(settings.rtp * 100).toFixed(2)}</li>
            <li>• Blackjack ödeme: 1'e 2.5 (bahis 1 ise kazanç 2.5)</li>
            <li>• Normal kazanç: 1'e 2 (bahis 1 ise kazanç 2)</li>
          </ul>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-8 py-3 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50"
        >
          {saving ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
        </button>
      </form>
    </div>
  );
};

export default BlackjackSettings;
